module.exports = __webpack_public_path__ + "img/LV2.8a21864c.svg";